import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import api from 'api';
import InputField from 'components/InputField';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import useValidations from 'router/subrouters/Auth/hooks/useValidations';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';

import './ShareableLinkLastName.styles.scss';

type LastNameFormValues = {
  lastName: string;
};

type ShareableLinkLastNameProps = {
  className?: string;
  onSaved: () => void;
};

const ShareableLinkLastName: React.FC<ShareableLinkLastNameProps> = (props) => {
  const { className, onSaved } = props;

  const { currentUser, updateCurrentUser } = useContext(CurrentUserContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const commonValidations = useValidations();

  const { t } = useTranslation();

  const classes = classNames('shareable-link-last-name', className);

  const saveLastName = useCallback(
    async ({ lastName }: LastNameFormValues) => {
      try {
        const {
          data: { user },
        } = await api.users.patchUser(currentUser._id, {
          lastName: lastName.trim(),
        });

        updateCurrentUser(user);
        onSaved();
      } catch (e) {
        popServerError(e);
      }
    },
    [currentUser._id, onSaved, popServerError, updateCurrentUser],
  );

  return (
    <ShareableLinkLockScreen
      className={classes}
      title={t('secureLinkLastNameTitle')}
      description={t('secureLinkLastNameDescription')}
    >
      <Form<LastNameFormValues>
        onSubmit={saveLastName}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name="lastName"
              component={InputField}
              label={t('lastName')}
              required
              validate={commonValidations.name}
            />

            <Button type="submit" disabled={submitting}>
              {t('continue')}
            </Button>
          </form>
        )}
      />
    </ShareableLinkLockScreen>
  );
};

export default ShareableLinkLastName;
